import { render } from "./RouteSettings.vue?vue&type=template&id=7079117a&scoped=true"
import script from "./RouteSettings.vue?vue&type=script&lang=ts"
export * from "./RouteSettings.vue?vue&type=script&lang=ts"

import "./RouteSettings.vue?vue&type=style&index=0&id=7079117a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7079117a"

export default script